/*
 * @Author: your name
 * @Date: 2022-03-03 19:59:16
 * @LastEditTime: 2022-03-26 17:16:05
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\utils\compute-service.js
 */


/**  
 * 时间计算  
 * @param {*} timeStemp 时间戳  
 * @param {*} flag 格式符号  
 */  
const AddDay = function(date, offset) { 
    if (date instanceof Date && !isNaN(offset)) {
        let givenDay = date.getDay();
        let newDay = givenDay + offset;
        date.setDate(newDay);
        return date;
    }
    throw Error('argument type error');
}

const AddMonth = function(date, offset) {
    if (date instanceof Date && !isNaN(offset)) {
        let givenMonth = date.getMonth();
        let newMonth = givenMonth + offset;
        date.setMonth(newMonth);
        return date;
    }
    throw Error('argument type error');
}

const AddYear = function(date, offset) { 
    if (date instanceof Date && !isNaN(offset)) {
        let givenYear = date.getFullYear();
        let newYear = givenYear + offset;
        date.setFullYear(newYear);
        return date;
    }
    throw Error('argument type error');
}

export default {
    AddDay,
    AddMonth,
    AddYear,
}